export const PARAM_CONTROL_TYPE_TEXTBOX = "TEXTBOX";
export const PARAM_CONTROL_TYPE_DROPDOWN = "DROPDOWN";
export const PARAM_CONTROL_TYPE_DATETIME = "DATETIME";
export const PARAM_CONTROL_TYPE_PARAM = "PARAM";
export const PARAM_CONTROL_TYPE_CUSTOM_SELECT = "CUSTOMSELECT";

export const IS_ZERO = 0;
export const ACCOUNT_PAGE_SIZE=10;
export const ACCOUNT_FIRST_PAGE = 1;